import { withTranslation } from "react-i18next";
import jobLogo from "../../assets/joblogo.jpg";
import location from "../../assets/location.svg";
import * as moment from "moment";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import routeNames from "../../routes/routeNames";
import { showNotification } from "@mantine/notifications";

const JobSlide = ({ data }) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("userData"));

  const handleViewJob = () => {
    if (user?.id) {
      navigate(`/job/${data.key}`);
    } else {
      showNotification({
        title: "Oops!",
        message: "Please Login to view job details!",
        color: "red",
      });
      navigate(routeNames.general.login);
    }
  };
  return (
    <div
      className="d-flex p-3 flex-column shadow bg-white mb-3 jobslide"
      onClick={handleViewJob}
    >
      <div className="d-flex gap-3 ">
        <img
          src={data?.logo || jobLogo}
          width="120px"
          height="120px"
          className="rounded-circle"
          style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
          alt={data?.name}
        />
        <div className="d-flex flex-column justify-content-between">
          <div className="d-flex flex-column gap-0 loc-ss">
            <h6 className="text-dark">{data.title}</h6>
            <div className="d-flex">
              <img
                src={jobLogo}
                width="20px"
                height="20px"
                style={{ marginRight: "5px" }}
                alt={data?.name}
              />

              <h6 className="text-info">{data.company}</h6>
            </div>
            <div className="d-flex">
              <img
                src={location}
                width="20px"
                height="20px"
                style={{ marginRight: "5px" }}
                alt={data?.name}
              />
              <h6 className="text-info">{data.location}</h6>
            </div>
            <h6 className="text-info">
              {data.remote ? "Remote Position" : "On-site Position"}
            </h6>
          </div>
          <h6
            style={{
              color: "rgb(0,0,0,0.5)",
              fontSize: "12px",
              marginBottom: "0px",
            }}
          >
            Posted on: {new moment(data.date).format("DD MMM YYYY")}
          </h6>
        </div>
      </div>
      <h6 className="text-info mt-2 mb-0">About Job</h6>
      <p className="description mt-0">{data.description}</p>
    </div>
  );
};
export default withTranslation()(JobSlide);
